import toast from "react-hot-toast";
export var msg = {
  title: function title(crumb) {
    return "".concat(process.env.__APP_NAME, ": Admin / ").concat(Array.isArray(crumb) ? crumb.join(" / ") : crumb);
  },
  app: 'Evnts',
  password: 'Password',
  profile: 'Profile',
  org: "Organization",
  org_nm: 'Organization Name',
  signuprequest: "Signup Request",
  audit: "Audit",
  orguser: "Org User"
};
export var __feedback = function __feedback(res) {
  res.success && toast.success(res.success.join("\n"));
  res.error && toast.error(res.error.join("\n"));
};